import React, {Component} from "react"
import styled from "styled-components"

import {H2, H4} from "@irati/ui/src/Headings"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Form from "@irati/ui/src/Form"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import Description from "@irati-web/fields/companyValues/Description"
import Header from "@irati-web/fields/companyValues/Header"
import Tag from "@irati-web/fields/companyValues/Tag"
import TrophyField from "@irati-web/fields/trophy"
import padding from "@irati/ui/src/global/padding"
import {CompanyValue, Trophy} from "@irati/companyvalues/types"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import ErrorText from "@irati/ui/src/ErrorText"
import id from "@irati/utils/id"

const StyledDiv = styled.div`
  margin: 0 auto ${({theme}) => theme.spacing.three};
  text-align: center;
  width: 600px;
`

const StyledH2 = styled(H2)`
  margin: ${padding.small} 0 0;
`

const StyledH4 = styled(H4)`
  margin: 40px 0 ${padding.large};
`

const StyledValidationButton = styled(ValidationButton)`
  margin-top: 40px;
`

const FIXED_SLIDER_WIDTH_FOR_COMPANY_VALUES = "600px"

interface Props extends InjectIntl {
  apolloState: ApolloState,
  buttonText: string,
  companyValue: CompanyValue,
  headerText: string,
  onChange(property: string, value: string): void,
  onChangeIcon(value: Trophy): void,
  onSubmit(companyValue: CompanyValue): void
}

class CompanyValuesForm extends Component<Props> {
  static defaultProps = {
    id: "companyValuesForm"
  }

  handleTrophySelect = (trophy: Trophy) => {
    this.props.onChangeIcon(trophy)
  }

  render() {
    const {apolloState, buttonText, companyValue, headerText, intl, onChange, onSubmit} = this.props

    const trophy = {
      trophy: companyValue.icon
    }

    return (
      <StyledDiv>
        <StyledH2>
          <FormattedMessage id={headerText} />
        </StyledH2>
        <StyledH4>
          <FormattedMessage id="admin.companyValues.form.body" />
        </StyledH4>
        <Form form="create-company-value">
          <Header id={id("valueName", this.props)} companyValue={companyValue} onChange={onChange} />
          <Description id={id("valueDescription", this.props)} companyValue={companyValue} maxLength={280} onChange={onChange} />
          <TrophyField
            componentToHideOnExpand={() => <Tag id={id("valueTag", this.props)} companyValue={companyValue} onChange={onChange} />}
            sliderWidth={FIXED_SLIDER_WIDTH_FOR_COMPANY_VALUES}
            item={trophy}
            onChange={this.handleTrophySelect} />
        </Form>
        <StyledValidationButton
          apolloState={apolloState}
          full
          large
          loading={intl.formatMessage({id: "admin.companyValues.form.loading"})}
          onClick={() => onSubmit(companyValue)}
          primary>
          <FormattedMessage id={buttonText} />
        </StyledValidationButton>
        {apolloState.error && <ErrorText>{apolloState.errorMsg}</ErrorText>}
      </StyledDiv>
    )
  }
}

export default injectIntl(CompanyValuesForm)
